import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, HostListener, ViewChild } from '@angular/core';
import { ConfirmationService, FilterMetadata, SortEvent } from 'primeng/api';
import { AuthenticationService } from '../core/services/authentication.service';
import { CanComponentDeactivate } from '../utility/can-exit.guard';
import { AdministrationBean } from './model/AdministrationBean';
import { AdministrationService } from './services/administration-service';
import { Table } from 'primeng/table';
import { ServiceType } from 'src/app/shared/Enums';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from './services/session-storage.service';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.css']
})
export class AdministrationComponent implements CanComponentDeactivate, AfterViewInit, AfterContentChecked {
  default = {
    "automaticActivationFlag"
      :
      false,
    "routingType"
      :
      "EXPLICIT"
  };
  @ViewChild('dt1') dt1!: Table;
  @ViewChild('paginationAdmin') paginationAdmin!: NgbPagination;

  administration: AdministrationBean[];
  allAdministration: AdministrationBean[];
  allAdministrationStable: AdministrationBean[];

  newInref: boolean = false;
  tableName: string = 'infrefTable';
  sortField: string;
  ServiceType: ServiceType;
  sortOrder: number;
  infRef: AdministrationBean
    = this.adminService.infrefLocal = this.default;
  canChangePage: boolean;

  editInref: boolean;

  constructor(
    private adminService: AdministrationService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    private sessionStorageService: SessionStorageService
  ) { }

  isSupportAdmin: boolean;
  isSuperAdmin: boolean;
  chnagePage = false;

  totalRecords: number;
  currentPage = 1;
  rowsPerPage = 15;
  currentSort: SortEvent;

  dataInitialized: boolean = false;

  @HostListener("window:beforeunload")
  canDeactivate(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (JSON.stringify(this.infRef) !== JSON.stringify(this.adminService.infrefLocal)) {
        this.confirmationService.confirm({
          message:
            'Du er ved at navigere væk fra en side med ændrede data uden at gemme først. Ønsker du at fortsætte?',
          header: 'Ændringer er ikke gemt',
          rejectLabel: 'Nej',
          acceptLabel: 'Ja',
          accept: () => {
            this.adminService.infrefLocal = this.infRef = this.default;
            resolve(true);
          },
          reject: () => {
            resolve(false);
          },
        });
      }
      else {
        resolve(true);
      }
    });
  }

  ngOnInit() {
    this.isSupportAdmin = (this.authenticationService.getAppRole() == "supporter");
    this.isSuperAdmin = (this.authenticationService.getAppRole() == "admin");
    this.sortField = 'infRefName';
    this.sortOrder = 1;
    if (sessionStorage.getItem(this.tableName)) {
      let tableStorage = JSON.parse(sessionStorage.getItem(this.tableName) + "");
      this.sortField = tableStorage.sortField
        ? tableStorage.sortField
        : this.sortField;
      this.sortOrder = tableStorage.sortOrder
        ? tableStorage.sortOrder
        : this.sortOrder;
    }
    this.adminService.getAdministration().then((data) => {
      let data1 = [];
      if (data)
        for (let d of data) {
          d.changedDate = new Date(d.changedDate);
          if (d.automaticActivationFlag)
            d.flagString = 'Ja';
          else
            d.flagString = 'Nej'
          data1.push(d);

        }
      this.allAdministration = data1;
      this.allAdministrationStable = data1;
      this.totalRecords = data1.length;
      if (this.showPagination) {
        const firstItemIndex = (this.currentPage - 1) * this.rowsPerPage;
        this.administration = this.allAdministration.slice(firstItemIndex, firstItemIndex + this.rowsPerPage);
        
      }
      else {
        this.administration = data1;
      }

      this.dataInitialized = true;
      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    const savedStateString = sessionStorage.getItem(this.tableName);
    if (savedStateString) {
      const savedState = JSON.parse(savedStateString);
      if (savedState && savedState.first !== undefined && savedState.rows !== undefined) {
        this.dt1.first = savedState.first;
        this.dt1.rows = savedState.rows;
      }
    }
  }

  ngAfterContentChecked(): void {
    if (this.dataInitialized && this.dt1?.value) {
      this.dataInitialized = false;
      this.inputChange("", "");
      this.initPagination();
    }
  }

  onNyInref() {
    this.infRef = {};
    this.newInref = true;
  }

  onRowSelect(event: any) {
    this.infRef = event.data;
    this.editInref = true;
  }

  editCancel() {
    this.editInref = false;
    this.newInref = false;
    this.infRef = this.adminService.infrefLocal = this.default;
    this.ngOnInit();
  }

  editSubmit() {
    this.editInref = false;
    this.newInref = false;
    this.adminService.infrefLocal = this.infRef = this.default;
    this.ngOnInit();
  }
  getServiceTypeText(serviceType: string): string {
    switch (serviceType) {
      case 'FILSERVICE':
        return ServiceType.FILSERVICE;
      case 'WEBSERVICE':
        return ServiceType.WEBSERVICE;
      default:
        return '';
    }
  }

  onPageChange(pageNumber: number) {
    this.savePagination(pageNumber);
    this.currentPage = pageNumber;
    this.administration = this.allAdministration.slice((pageNumber - 1) * this.rowsPerPage,
      (pageNumber - 1) * this.rowsPerPage + this.rowsPerPage);
  }

  get showPagination(): any {
    return this.rowsPerPage && (this.rowsPerPage > 0) && (this.allAdministration?.length > this.rowsPerPage);
  }

  customSort(event: SortEvent) {
    if (!this.currentSort) {
      this.currentSort = event;
    }

    let property = event.field as keyof AdministrationBean;

    if (property) {

      this.allAdministration.sort((data1: any, data2: any) => {
        let value1 = data1[property];
        let value2 = data2[property];
        let result = null;

        let newOrder = event.order ? event.order : 0;

        result = value1?.toString().localeCompare(value2?.toString());

        return (newOrder * result);
      })
    }

    if(this.allAdministration?.length < this.rowsPerPage) {
      this.administration = this.allAdministration.slice(0, this.rowsPerPage);
    }

    if (this.currentSort.field !== event.field || this.currentSort.order !== event.order) {
      this.paginationAdmin?.pageChange?.emit(1);
      if (this.paginationAdmin) {
        this.paginationAdmin.page = 1;
      }
      this.currentSort = event;
    }

    if (this.paginationAdmin) {
      this.paginationAdmin.page = 1;
    }

  }

  inputChange(inputValue: string, field: string) {
    if (this.allAdministration) {
      let filters = Object.entries(this.dt1.filters).map((e) => ({ [e[0]]: e[1] }));
      if (field && filters) {
        for (const filter of filters) {
          if (filter[field] != null) {
            this.dt1.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          } else {
            this.dt1.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          }
        }
      } else {
        this.dt1.filters[field] = {
          value: inputValue,
          matchMode: "contains"
        }
      }

      filters = Object.entries(this.dt1.filters).map((e) => ({ [e[0]]: e[1] }));

      this.allAdministration = this.allAdministrationStable;

      for (const f of filters) {
        let property = Object.keys(f).at(0) as keyof AdministrationBean;
        let filterMetadata = f[property] as FilterMetadata;
        if (filterMetadata.value) {
          this.allAdministration = this.allAdministration.filter(data => data[property]?.toString().toLowerCase().includes(filterMetadata.value.toLowerCase()));
        }
      }
      this.totalRecords = this.allAdministration.length;
      if (this.allAdministration?.length > 0) {
        this.paginationAdmin?.pageChange?.emit(1);
        this.currentPage = 1;
        if(!this.paginationAdmin) {
          this.onPageChange(1);
        } else {
          this.paginationAdmin.page = 1;
        }
      }
    }

  }

  private savePagination(page: number) {
    this.sessionStorageService.put(this.sessionStorageService.ADMINISTRATION_PAGINATION, page);
  }

  private initPagination() {
    let page = this.sessionStorageService.get(this.sessionStorageService.ADMINISTRATION_PAGINATION);
    if (this.paginationAdmin?.pageCount < page) {
      this.paginationAdmin?.pageChange?.emit(this.paginationAdmin.pageCount);
      if (this.paginationAdmin) {
        this.paginationAdmin.page = this.paginationAdmin.pageCount;
      }
    } else {
      this.paginationAdmin?.pageChange?.emit(page);
      if (this.paginationAdmin) {
        this.paginationAdmin.page = page;
      }
    }
  }

}

